import {Component, ElementRef, input, output, ViewChild} from '@angular/core';


/**
 * SlideShowModal Component
 *
 * Responsible for:
 * - Modal container layout and positioning
 * - Responsive design breakpoints
 * - Background blur and styling effects
 * - Mobile-specific layout adjustments
 */
@Component({
  selector: 'app-slide-show-modal',
  standalone: true,
  imports: [],
  templateUrl: './slide-show-modal.component.html',
  styleUrl: './slide-show-modal.component.scss'
})
export class SlideShowModalComponent {
  // Inputs
  isPlaying = input<boolean>(false);

  // Element reference for click handling
  @ViewChild('modalContainer') modalContainer?: ElementRef<HTMLDivElement>;

  // Output events
  modalClick = output<MouseEvent>();

  /**
   * Handle click events on the modal container
   * @param event The mouse event
   */
  onModalClick(event: MouseEvent): void {
    this.modalClick.emit(event);
  }
}
